import { c as _c } from "react/compiler-runtime";
import { LinkExternal01Icon } from '@systemeio/icons';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionTagEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { FormSelect } from 'shared/components';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ActionRemoveTagItemProps extends EditActionItemInterface<ActionTagEditInterface> {}
const ActionRemoveTagItem = t0 => {
  const $ = _c(15);
  const {
    actions,
    action,
    onDelete,
    setRules,
    errors,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== idx || $[1] !== onDelete) {
    t1 = () => onDelete(idx);
    $[0] = idx;
    $[1] = onDelete;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== action.id || $[4] !== action.tag || $[5] !== actions || $[6] !== errors.automationActions || $[7] !== idx || $[8] !== setRules || $[9] !== t) {
    t2 = t3 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t3;
      return <FormSelect onOpen={onOpen} required={true} label={renderActionLabel({
        label: t("dashboard.tag.title"),
        additionalLabel: action.tag.id ? <LinkWithoutPrefetch href={`/contacts?filter=%5B%7B"searchValue"%3A"${action.tag.id}"%2C"compareOperation"%3A"IN_LIST"%2C"searchField"%3A"tag"%7D%5D`} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><LinkExternal01Icon className="text-icon-tertiary transition-base group-focus-visible:text-icon-accent hover:text-icon-link-hover" /></LinkWithoutPrefetch> : undefined
      })} placeholder={t("dashboard.automation_rule.choose_tag")} value={action.tag.id} data={data.tagData} staticData={getDataFromObj(action.tag)} onChange={data_0 => setRules(prev => ({
        ...prev,
        actions: actions.map((el, i) => {
          if (idx === i) {
            return {
              ...el,
              tag: {
                id: data_0
              }
            };
          } else {
            return el;
          }
        })
      }))} error={errors.automationActions[action.id]?.tag?.join("")} />;
    };
    $[3] = action.id;
    $[4] = action.tag;
    $[5] = actions;
    $[6] = errors.automationActions;
    $[7] = idx;
    $[8] = setRules;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== action.type || $[12] !== t1 || $[13] !== t2) {
    t3 = <EditActionWrapper slug={action.type} onDelete={t1}>{t2}</EditActionWrapper>;
    $[11] = action.type;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default ActionRemoveTagItem;